export default (conditional, conditionalClassName, baseClassName) => {
  return conditional ? `${baseClassName} ${conditionalClassName}` : `${baseClassName}`;
};
